module.exports = __webpack_public_path__ + "img/Unidad18-4.f97e2c9e.png";